import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { PoliceDefaut } from '../helpers/contants';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { showCompanionRestriction } from '../redux/companionSlice';
import { capture } from '../services/analytics';

export default function CompanionRestriction() {
  const feature = useSelector(state => state.companion.restrictedFeature);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (feature) capture('companion_restricted_feature_viewed', { feature });
  }, [feature]);
  const close = () => dispatch(showCompanionRestriction(''));
  return (
    <Modal
      className="d-flex align-items-center"
      show={Boolean(feature)}
      onHide={close}
      style={{ fontFamily: PoliceDefaut }}
      aria-labelledby="companion-restriction-title"
    >
      <Modal.Header
        closeVariant="white"
        closeButton
        style={{ color: 'white', backgroundColor: '#134491' }}
      >
        <h4 id="companion-restriction-title">{feature}</h4>
      </Modal.Header>
      <Modal.Body>
        Connectez-vous à votre compte pour accéder à cette fonctionnalité. Vous pouvez continuer à
        consulter l’événement en mode invité.
        <div className="d-flex justify-content-end flex-wrap gap-2 mt-3">
          <Button
            className="btn-recup"
            onClick={() => {
              capture('companion_login_clicked', { feature });
              close();
              navigate('/login');
            }}
          >
            Se connecter
          </Button>
          <Button className="btn-recup2" variant="secondary" onClick={close}>
            Continuer la visite
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
